import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {array, object, string} from 'yup'

import {COMMENT_MAX_LENGTH, getYesNoWithCommentSchema, TEXT_MAX_LENGTH} from './yes-no.validators'

const slippageCreepCheckReadingSchema = (t: TFunction) =>
  object().shape({
    first: string().max(TEXT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})),
    second: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    third: string().max(TEXT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})),
    comment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    )
  })

export const getKilnSectionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    slippageCreepChecks: array().of(slippageCreepCheckReadingSchema(t)),
    kilnBearingsOilLevelLevelsOk: getYesNoWithCommentSchema({t}),
    kilnBearingsCoolingWaterFlowSufficientFlow: getYesNoWithCommentSchema({t}),
    kilnThrustRollerOilLevelLevelsOk: getYesNoWithCommentSchema({t}),
    kilnThrustRollerKilnPositionOnThrust: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnThrustRollerKilnPositionFloating: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnThrustRollerKilnPositionUphill: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnThrustRollerKilnPositionComment: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnFeedEndSealPlatesBoltsCablesNormal: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnFeedEndSealPlatesBoltsCablesDeficiency: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnFeedEndSealPlatesBoltsCablesComment: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnFeedEndSealMaterialLeak: getYesNoWithCommentSchema({t}),
    kilnDischargeSealPlatesCablesShroudNormal: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnDischargeSealPlatesCablesShroudDamaged: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnDischargeSealPlatesCablesShroudComment: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    kilnDischargeSealMaterialLeakExcessiveSpillage: getYesNoWithCommentSchema({t}),
    noseRingNoseCastingsNormal: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    noseRingNoseCastingsDamaged: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    noseRingNoseCastingsComment: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    noseRingNoseRingFansOperatingProperly: getYesNoWithCommentSchema({t}),
    noseRingFansGreased3ShotsOfGrease: getYesNoWithCommentSchema({t}),
    shellFansBeltsBearingsMotorOperatingProperly: getYesNoWithCommentSchema({t})
  })
